import React, { useState, useCallback } from 'react'
import loadable from '@loadable/component'
import SearchInput from './Search.Input'
import SearchIcon from './Search.Icon'

const SearchComponent = loadable(() => import('./Search'))

const Search = () => {
  const [searchLoaded, setSearchLoaded] = useState()

  const loadSearchModule = useCallback(() => {
    SearchComponent.load().then(() => {
      setSearchLoaded(true)
    })
  })

  const loadSearch = useCallback(() => {
    loadSearchModule()
  })

  return searchLoaded ? (
    <SearchComponent isFocused={true} setSearchLoaded={setSearchLoaded} />
  ) : (
    <SearchInput loadSearch={loadSearch} />
  )
}

export default Search
